import React from 'react'

const Footer = () => {
  return (
    <footer className="bg-backgroundDark border-t border-accent py-8 sm:py-10 md:py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content - Mobile First Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Brand Section */}
          <div className="text-center sm:text-left">
            <h3 className="font-heading text-xl sm:text-2xl font-bold text-primary mb-3 sm:mb-4">
              Aryan Mehta
            </h3>
            <p className="font-body text-textSecondary leading-relaxed text-sm sm:text-base">
              Full-Stack Developer focused on building scalable web applications, backend APIs, and performant user interfaces. Experience working across frontend, backend, and database layers.
            </p>
          </div>

          {/* Quick Links */}
          <div className="text-center sm:text-left">
            <h4 className="font-heading text-base sm:text-lg font-semibold text-textPrimary mb-3 sm:mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2 font-body text-sm sm:text-base">
              <li>
                <a href="#about" className="text-textSecondary hover:text-primary transition-colors duration-300">
                  About Me
                </a>
              </li>
              <li>
                <a href="#skills" className="text-textSecondary hover:text-primary transition-colors duration-300">
                  Skills
                </a>
              </li>
              <li>
                <a href="#projects" className="text-textSecondary hover:text-primary transition-colors duration-300">
                  Projects
                </a>
              </li>
              <li>
                <a href="#contact" className="text-textSecondary hover:text-primary transition-colors duration-300">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Connect Section */}
          <div className="text-center sm:text-left sm:col-span-2 lg:col-span-1">
            <h4 className="font-heading text-base sm:text-lg font-semibold text-textPrimary mb-3 sm:mb-4">
              Let's Connect
            </h4>
            
            {/* Social Media Icons - Mobile Optimized */}
            <div className="flex justify-center sm:justify-start space-x-3 sm:space-x-4 mb-3 sm:mb-4">
              <a 
                href="mailto:techstack.developer04@gmail.com" 
                className="bg-accent p-2 sm:p-3 rounded-lg hover:bg-primary/20 transition-colors duration-300 group"
                aria-label="Email"
              >
                <svg className="w-4 sm:w-5 h-4 sm:h-5 text-textSecondary group-hover:text-primary transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </a>
              <a 
                href="https://www.linkedin.com/in/aaaaarryyan/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-accent p-2 sm:p-3 rounded-lg hover:bg-primary/20 transition-colors duration-300 group"
                aria-label="LinkedIn"
              >
                <svg className="w-4 sm:w-5 h-4 sm:h-5 text-textSecondary group-hover:text-primary transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" clipRule="evenodd" />
                </svg>
              </a>
              <a 
                href="https://github.com/TheAryan04" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-accent p-2 sm:p-3 rounded-lg hover:bg-primary/20 transition-colors duration-300 group"
                aria-label="GitHub"
              >
                <svg className="w-4 sm:w-5 h-4 sm:h-5 text-textSecondary group-hover:text-primary transition-colors duration-300" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
            
            <p className="font-body text-textSecondary text-xs sm:text-sm">
              Open to internships, entry-level developer roles, and collaborative projects.
            </p>
          </div>
        </div>

        {/* Bottom Section - Mobile Optimized */}
        <div className="border-t border-accent pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
            <p className="font-body text-textSecondary text-xs sm:text-sm text-center sm:text-left">
              © {new Date().getFullYear()} Aryan Mehta. All rights reserved.
            </p>
            
            {/* Tech Stack - Mobile Responsive */}
            <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4 font-body text-xs sm:text-sm">
              <span className="text-textSecondary">Portfolio built using
</span>
              <div className="flex items-center space-x-2">
                <span className="text-primary font-semibold">React</span>
                <span className="text-textSecondary">•</span>
                <span className="text-primary font-semibold">Tailwind CSS</span>
                <span className="text-textSecondary">•</span>
                <span className="text-primary font-semibold">Vite</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
